import FeedbackView from '@/template/views/FeedbackView.vue';
export var feedbackRoutes = [
    {
        name: 'organisationYearlyReportFeedback',
        path: '/organisationYearlyReportFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.OrganisationYearlyReportFeedback',
            recordableType: 'OrganisationYearlyReport',
            type: 'OrganisationYearlyReportFeedback'
        }
    },
    {
        name: 'aidTargetYearlyReportFeedback',
        path: '/aidTargetYearlyReportFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.AidTargetYearlyReportFeedback',
            recordableType: 'AidTargetYearlyReport',
            type: 'AidTargetYearlyReportFeedback'
        }
    },
    {
        name: 'aidProposal',
        path: '/aidProposal/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.AidProposal',
            recordableType: 'AidApplication',
            type: 'AidProposal'
        }
    },
    {
        name: 'aidDecision',
        path: '/aidDecision/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.AidDecision',
            recordableType: 'AidApplication',
            type: 'AidDecision'
        }
    },
    {
        name: 'accountNumberRequestFeedback',
        path: '/accountNumberRequestFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.AccountNumberRequestFeedback',
            recordableType: 'AccountNumberRequest',
            type: 'AccountNumberRequestFeedback'
        }
    },
    {
        name: 'expandedsbeFeedback',
        path: '/expandedsbeFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.ExpandedStrategyAndBudgetaryEstimateFeedback',
            recordableType: 'ExpandedStrategyAndBudgetaryEstimate',
            type: 'ExpandedStrategyAndBudgetaryEstimateFeedback'
        }
    },
    {
        name: 'paymentPlanFeedback',
        path: '/paymentPlanFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.PaymentPlanFeedback',
            recordableType: 'PaymentPlan',
            type: 'PaymentPlanFeedback'
        }
    },
    {
        name: 'paymentRequestERFeedback',
        path: '/paymentRequestERFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.PaymentRequestExpenseReportFeedback',
            recordableType: 'PaymentRequestExpenseReport',
            type: 'PaymentRequestExpenseReportFeedback'
        }
    },
    {
        name: 'refundRequestFeedback',
        path: '/refundRequestFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.RefundRequestFeedback',
            recordableType: 'RefundRequest',
            type: 'RefundRequestFeedback'
        }
    },
    {
        name: 'claimForRecoveryFeedback',
        path: '/claimForRecoveryFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.ClaimForRecoveryFeedback',
            recordableType: 'ClaimForRecovery',
            type: 'ClaimForRecoveryFeedback'
        }
    },
    {
        name: 'investmentBudgetaryEstimateFeedback',
        path: '/investmentBudgetaryEstimateFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.InvestmentDecision.InvestmentBudgetaryEstimate',
            recordableType: 'InvestmentReport',
            type: 'InvestmentReportFeedback'
        }
    },
    {
        name: 'investmentFinalReportFeedback',
        path: '/investmentFinalReportFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.InvestmentDecision.InvestmentFinalReport',
            recordableType: 'InvestmentReport',
            type: 'InvestmentReportFeedback'
        }
    },
    {
        name: 'deadlineChangeFeedback',
        path: '/deadlineChangeFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.DeadlineChangeFeedback',
            recordableType: 'DeadlineChange',
            type: 'DeadlineChangeFeedback'
        }
    },
    {
        name: 'purposeChangeFeedback',
        path: '/purposeChangeFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.PurposeChangeFeedback',
            recordableType: 'PurposeChange',
            type: 'PurposeChangeFeedback'
        }
    },
    {
        name: 'targetChangeFeedback',
        path: '/targetChangeFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.TargetChangeFeedback',
            recordableType: 'TargetChange',
            type: 'TargetChangeFeedback'
        }
    },
    {
        name: 'summaryReportFeedback',
        path: '/summaryReportFeedback/:id',
        component: FeedbackView,
        meta: {
            mainNav: false,
            title: 'Forms.SummaryReportFeedback',
            recordableType: 'SummaryReport',
            type: 'SummaryReportFeedback'
        }
    }
];
